/** Убирает все пробельные символы — в email/login и пароле их быть не должно. */
export function stripAuthWhitespace(value: string | null | undefined): string {
  return String(value ?? '').replace(/\s+/g, '');
}

/**
 * Мягкая проверка email: local@domain с точкой в домене.
 * Допускает цифры и дефисы в домене (163.com, growapp-studio.com).
 */
export function isValidEmail(value: string | null | undefined): boolean {
  const email = stripAuthWhitespace(value).toLowerCase();
  if (email.length < 5 || email.length > 254) return false;
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}
